import { render, staticRenderFns } from "./ConfirmSubmitServiceCost.vue?vue&type=template&id=524c4fd9&scoped=true&"
import script from "./ConfirmSubmitServiceCost.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSubmitServiceCost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c4fd9",
  null
  
)

export default component.exports